import { lazy } from "react";

// Auth routes — loaded eagerly since they're the entry point for unauthenticated users
import Register from "views/auth/register";
import Login from "views/auth/signin";

// All other views are lazy-loaded to eliminate the render-blocking chunk on /auth/login
const ChangePassword = lazy(() => import("views/examples/ChangePassword"));
const SearchForPlayer = lazy(() => import("views/examples/SearchForPlayer"));
const ForgotPassword = lazy(() => import("views/examples/ForgotPassword"));
const ComplaintForm = lazy(() => import("views/examples/ComplaintForm"));
const MyLicenses = lazy(() => import("views/examples/MyLicenses"));
const MySkypeRequests = lazy(() => import("views/examples/MySkypeRequests"));
const RequestedCities = lazy(() => import("views/examples/RequestedCities"));
const RequestedSports = lazy(() => import("views/examples/RequestedSports"));
const InstructionsReadFirst = lazy(() => import("views/examples/InstructionsReadFirst"));
const CollectiveAlumAndM4F = lazy(() => import("views/examples/CAAndM4F"));
const Ambassador4Brand = lazy(() => import("views/examples/Ambassador4Brand&Unkle501"));
const FanPostThisAd = lazy(() => import("views/examples/FanPostThisAd"));
const PayNow = lazy(() => import("views/examples/PayNow"));
const License = lazy(() => import("views/examples/License"));
const ThankYou = lazy(() => import("views/examples/ThankYou"));
const FilterPlayers = lazy(() => import("views/examples/FilterPlayers"));
const BuyRights = lazy(() => import("views/examples/BuyRights"));
const PlayerProfile = lazy(() => import("views/examples/PlayerProfile"));
const LicenseDetails = lazy(() => import("views/examples/LicenseDetails"));
const LicenseSubscriptionsDetails = lazy(() => import("views/examples/LicenseSubscriptionsDetails"));
const RosterInstituteChoice = lazy(() => import("views/examples/RosterInstituteChoice"));
const SchoolTeamRoster = lazy(() => import("views/examples/SchoolTeamRoster"));
const SearchTeamRoster = lazy(() => import("views/examples/SearchTeamRoster"));
const TeamRosterLists = lazy(() => import("views/examples/TeamRosterLists"));
const SearchResultDisplay = lazy(() => import("views/examples/SearchResultDisplay"));
const ResultDisplayDetails = lazy(() => import("views/examples/ResultDisplayDetails"));
const RosterTeamListDetail = lazy(() => import("views/examples/RosterTeamListDetail"));
const SubscribeBadge = lazy(() => import("views/examples/SubscribeBadge"));
const Resolution = lazy(() => import("views/examples/Resolution"));
const ResolutionChat = lazy(() => import("views/examples/ResolutionChat"));
const SessionBadges = lazy(() => import("views/examples/SessionBadges"));
const SessionalData = lazy(() => import("views/examples/SessionalData"));
const AddMementos = lazy(() => import("views/examples/AddMementos"));
const Wallet = lazy(() => import("views/examples/Wallet"));
const EndorseBadge = lazy(() => import("views/examples/EndorseBadge"));
const MyEndorse = lazy(() => import("views/examples/MyEndorse"));
const EndorseDetail = lazy(() => import("views/examples/EndorseDetail"));
const Profile = lazy(() => import("views/auth/profile"));
const TalkingBadgesDetail = lazy(() => import("views/examples/TalkingBadgesDetail"));
const PurchasedTalkingBadges = lazy(() => import("views/examples/PurchasedTalkingBadges"));
const Favorite = lazy(() => import("views/examples/Favorite"));
const HallOfFame = lazy(() => import("views/examples/HallOfFame"));
const ProtectMemorabilia = lazy(() => import("views/examples/ProtectMemorabilia"));
const FairUse = lazy(() => import("views/FairUse"));
const HowToFind = lazy(() => import("views/HowToFind"));
const ShopEndorsements = lazy(() => import("views/examples/ShopEndorsements"));
const SportBadgesHallOfFame = lazy(() => import("views/examples/SportBadges&HallOfFame"));
const LicenseTermsPublicDisplay = lazy(() => import("views/examples/LicenseTerms&PublicDisplay"));
const MyMementos = lazy(() => import("views/examples/MyMementos"));
const PurchasedContestBadges = lazy(() => import("views/examples/PurchasedContestBadges"));
const SharedResponsibility = lazy(() => import("views/examples/SharedResponsibility"));
const TutorialsInPage = lazy(() => import("views/examples/TutorialsInPage"));
const IntellectualProperty = lazy(() => import("views/examples/IntellectualProperty"));
const Contest = lazy(() => import("views/Contest"));
const BadgesGallery = lazy(() => import("views/BadgesGallery"));
const HappyToHelp = lazy(() => import("views/HappyToHelp"));
const AthleteBlogs = lazy(() => import("views/AthleteBlogs"));
const Dashboard = lazy(() => import("views/manager/Dashboard"));
const AddBlogs = lazy(() => import("views/manager/AddBlogs"));
const SeeBlogs = lazy(() => import("views/manager/SeeBlogs"));
const ManagerFhpAds = lazy(() => import("views/manager/ManagerFhpAds"));
const RemindPosts = lazy(() => import("views/manager/RemindPosts"));
const ManagerProfile = lazy(() => import("views/manager/ManagerProfile"));
const RequestManagerTeach = lazy(() => import("views/manager/RequestManagerTeach"));
const FanJobs = lazy(() => import("views/FanJobs"));
const Jobs = lazy(() => import("views/manager/Jobs"));
const CoinStats = lazy(() => import("views/examples/CoinStats"));
const Notifications = lazy(() => import("views/examples/Notifications"));
const FavoriteAthletes = lazy(() => import("views/examples/FavouriteAthletes"));
const SportsCommunityBadge = lazy(() => import("views/examples/SportsCommunityBadge"));
const ManagerTraining = lazy(() => import("views/examples/ManagerTraining"));
const VisibilityBoard = lazy(() => import("views/VisibilityBoard/index"));

var routes = [
  {
    path: "/player/:id/pay-now",
    component: PayNow,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/player/:id/license",
    component: License,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/player/:id/thank-you",
    component: ThankYou,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/search-player/filter-player",
    component: FilterPlayers,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/search-player/:id/buy-rights",
    component: BuyRights,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/search-player/:id/player-profile",
    component: PlayerProfile,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/search-player/:id/endorse-badge",
    component: EndorseBadge,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/my-licenses/:id/license-detail",
    component: LicenseDetails,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/my-licenses/:id/license-subscriptions-detail",
    component: LicenseSubscriptionsDetails,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/roster-institute-choice",
    component: RosterInstituteChoice,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/school-team-roster/:states",
    component: SchoolTeamRoster,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/search-team-roster",
    component: SearchTeamRoster,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/team-roster-lists",
    component: TeamRosterLists,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/search-result-display",
    component: SearchResultDisplay,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/result-display-details/:teamID",
    component: ResultDisplayDetails,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/single/team/list",
    component: RosterTeamListDetail,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/fan/subscribe-badge",
    component: SubscribeBadge,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/happy-to-help",
    name: "Happy to help",
    icon: "ni ni-tv-2 text-primary",
    component: HappyToHelp,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/manager-training",
    name: "Want to be a Manager?",
    icon: "ni ni-user-tie text-primary",
    component: ManagerTraining,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/jobs",
    name: "Jobs",
    icon: "ni ni-tv-2 text-primary",
    component: FanJobs,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/instructions-read-first",
    name: "Instructions - Read FIRST",
    icon: "ni ni-tv-2 text-primary",
    component: InstructionsReadFirst,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/contest",
    name: "Contests",
    icon: "ni ni-tv-2 text-primary",
    component: Contest,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/how-to-find-athlete",
    name: "How To Find Athlete",
    icon: "ni ni-tv-2 text-primary",
    component: HowToFind,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/profile",
    name: "My Profile",
    icon: "ni ni-tv-2 text-primary",
    component: Profile,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/notification",
    name: "Notify me re:Favs",
    icon: "ni ni-tv-2 text-primary",
    component: Favorite,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/add-mementos",
    name: "Shop Mementos",
    icon: "ni ni-tv-2 text-primary",
    component: AddMementos,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/shop-endorsement",
    name: "Shop Endorsements",
    icon: "ni ni-tv-2 text-primary",
    component: ShopEndorsements,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/badges-gallery-seasonal",
    name: "Shop Seasonals",
    icon: "ni ni-tv-2 text-primary",
    component: BadgesGallery,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/badges-gallery-talking",
    name: "Shop Talking Badges",
    icon: "ni ni-tv-2 text-primary",
    component: BadgesGallery,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/sports-community-badge",
    name: "FHP Sports Community Badges",
    icon: "ni ni-tv-2 text-primary",
    component: SportsCommunityBadge,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/sport-badges-hall-of-fame",
    name: "Shop Sport Badges & Make Hall of fame",
    icon: "ni ni-tv-2 text-primary",
    component: SportBadgesHallOfFame,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/search-player",
    name: "Search for Player / Arrange Whatsapp/Zoom call",
    icon: "ni ni-tv-2 text-primary",
    component: SearchForPlayer,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/CollectiveAlums&Match4Future",
    name: "Match4Future.com",
    icon: "ni ni-tv-2 text-primary",
    component: CollectiveAlumAndM4F,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/Ambassador4Brand&Unkle501",
    name: "Chat - WITH ATHLETE OF CHOICE",
    icon: "ni ni-tv-2 text-primary",
    component: Ambassador4Brand,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/my-endorse-badge/:id/endorse-detail",
    component: EndorseDetail,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "ni ni-tv-2 text-primary",
    component: Notifications,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/license-terms-vs-public-display",
    name: "License terms vs Public Display",
    icon: "ni ni-tv-2 text-primary",
    component: LicenseTermsPublicDisplay,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/my-whatsapp/zoom-requests",
    name: "My Whatsapp/Zoom Requests",
    icon: "ni ni-tv-2 text-primary",
    component: MySkypeRequests,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/fan-post-this-ad",
    name: "Fan Post This Ad",
    icon: "ni ni-tv-2 text-primary",
    component: FanPostThisAd,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/raise-issue",
    name: "Raise Issue",
    icon: "ni ni-tv-2 text-primary",
    component: ComplaintForm,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/requested-cities",
    name: "Requested Cities",
    icon: "ni ni-tv-2 text-primary",
    component: RequestedCities,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/requested-sports",
    name: "Requested Sports",
    icon: "ni ni-tv-2 text-primary",
    component: RequestedSports,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/resolution",
    name: "Resolution",
    icon: "ni ni-tv-2 text-primary",
    component: Resolution,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/ResolutionChat/:id",
    component: ResolutionChat,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/change-password",
    name: "Change Password",
    icon: "ni ni-tv-2 text-primary",
    component: ChangePassword,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/markers",
    name: "Make HALL of FAME Marker",
    icon: "ni ni-tv-2 text-primary",
    component: HallOfFame,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/my-endorse-badge",
    name: "My Endorsement Badges",
    icon: "ni ni-tv-2 text-primary",
    component: MyEndorse,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/athlete-sessionals-buy",
    name: "My Seasonal Badges",
    icon: "ni ni-tv-2 text-primary",
    component: SessionalData,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/my-licenses",
    name: "My Sport Badges + Hall of Fame ",
    icon: "ni ni-tv-2 text-primary",
    component: MyLicenses,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/purchased-talking-badges",
    name: "My Talking Badges ",
    icon: "ni ni-tv-2 text-primary",
    component: PurchasedTalkingBadges,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/purchased-contest-badges",
    name: "My Contest Badges",
    icon: "ni ni-tv-2 text-primary",
    component: PurchasedContestBadges,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/my-mementos",
    name: "My Mementos",
    icon: "ni ni-tv-2 text-primary",
    component: MyMementos,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/fan/protect-memorabilia",
    name: "Protect  Memorabilia",
    icon: "ni ni-tv-2 text-primary",
    component: ProtectMemorabilia,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/fair-use",
    name: "Fair Use",
    icon: "ni ni-tv-2 text-primary",
    component: FairUse,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/video-tutorials",
    name: "Tutorials",
    icon: "ni ni-tv-2 text-primary",
    component: TutorialsInPage,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/shared-responsibility",
    name: "Shared Responsibility",
    icon: "ni ni-tv-2 text-primary",
    component: SharedResponsibility,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/intellectual-property",
    name: "Intellectual Property",
    icon: "ni ni-tv-2 text-primary",
    component: IntellectualProperty,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/session-badges/:id",
    component: SessionBadges,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/buy-talking-badges/:id",
    component: TalkingBadgesDetail,
    layout: "/fan",
    showInMenu: false,
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/register",
    name: "Register",
    icon: "ni ni-circle-08 text-pink",
    component: Register,
    layout: "/auth",
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    icon: "ni ni-key-25 text-info",
    component: ForgotPassword,
    layout: "/auth",
  },
  {
    path: "/athlete-blogs",
    name: "Athlete Blogs",
    icon: "ni ni-tv-2 text-primary",
    component: AthleteBlogs,
    layout: "/fan",
    showInMenu: true,
  },
  // {
  //   path: "/coins-stats",
  //   name: "Coin Stats",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: CoinStats,
  //   layout: "/fan",
  //   showInMenu: true,
  // },
  {
    path: "/favourite-athletes",
    name: "Favourite Athletes ShortCuts",
    icon: "ni ni-tv-2 text-primary",
    component: FavoriteAthletes,
    layout: "/fan",
    showInMenu: true,
  },
  {
    path: "/visibility-board",
    name: "Visibility Board",
    icon: "ni ni-tv-2 text-primary",
    component: VisibilityBoard,
    layout: "/fan",
    showInMenu: true,
  },
  // *****************Manager pages**************************
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Dashboard,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/Manager-profile",
    name: "Profile",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerProfile,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/manager-forum",
    name: "Manager Forum",
    icon: "ni ni-tv-2 text-primary",
    component: SeeBlogs,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/add-forum",
    name: "Add Forum",
    icon: "ni ni-tv-2 text-primary",
    component: AddBlogs,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/wallet",
    name: "Wallet",
    icon: "ni ni-tv-2 text-primary",
    component: Wallet,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/upload-fhp-ads",
    name: "Upload FHP Ads",
    icon: "ni ni-tv-2 text-primary",
    component: ManagerFhpAds,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/jobs",
    name: "Jobs",
    icon: "ni ni-tv-2 text-primary",
    component: Jobs,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/remind-posts",
    name: "Remind posts",
    icon: "ni ni-tv-2 text-primary",
    component: RemindPosts,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/request-manager-teach",
    name: "Request Manager Teach",
    icon: "ni ni-tv-2 text-primary",
    component: RequestManagerTeach,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/coins-stats",
    name: "Coin Stats",
    icon: "ni ni-tv-2 text-primary",
    component: CoinStats,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/sports-community-badge",
    name: "FHP Sports Community Badges",
    icon: "ni ni-tv-2 text-primary",
    component: SportsCommunityBadge,
    layout: "/manager",
    showInMenu: true,
  },
  {
    path: "/visibility-board",
    name: "Visibility Board",
    icon: "ni ni-tv-2 text-primary",
    component: VisibilityBoard,
    layout: "/manager",
    showInMenu: true,
  },
];
export default routes;
